export const CircularsStyle = {
	mainWrapper: {
		display: 'flex',
		gap: '16px',
		marginTop: '16px',
	},
};
